import * as images from "./images";

export const diageo = [
  {
    img: images.corto,
    nome: "Perfect Negroni",
    ricetta: {
      it: "Tanqueray 10, Antica Formula Vermouth, Campari",
      en: "Tanqueray 10, Ancient Formula Vermouth, Campari",
    },
  },
  {
    img: images.lungo,
    nome: "Casamigos Paloma",
    ricetta: {
      it: "Casamigos blanco, pompelmo rosa, lime, agave",
      en: "Casamigos blanco, pink grapefruit, fresh lime, agave",
    },
  },
  // {
  //   img: images.uccello,
  //   nome: "Flamengo",
  //   ricetta: {
  //     it: "Ketel one, pesca, prosecco",
  //     en: "Ketel one, peach, prosecco",
  //   },
  // },
  {
    img: images.corto,
    nome: "Kentucky",
    ricetta: {
      it: "Bulleit rey, ciliegia, bitter al rosmarino, fumo di melo",
      en: "Bulleit rey, cherry, rosmary bitter, apple smoke",
    },
  },
];
